import classNames from "classnames";
import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { DayPicker } from "react-dates";
import CSSModules from "lib/utils/css-modules";

import st from "lib/utils/index";
import { OrderFullDecorator } from "lib/decorators/index";
import { Message, OrderSidebarPreview } from "lib/components/index";
import { stateSelector, STEPS, open, close, validate, submit, goBack, updateOrder, calculatePricing } from "./index";
import NewOrderProductModal from "./NewOrderProductModal/NewOrderProductModal";
import OrderScheduleForm from "modules/orders/OrderScheduleForm/OrderScheduleForm";
import NewOrderItemsForm from "./NewOrderItemsForm/NewOrderItemsForm";
import NewOrderCustomerDetailsForm from "./NewOrderCustomerDetailsForm/NewOrderCustomerDetailsForm";
import NewOrderPaymentsForm from "./NewOrderPaymentsForm/NewOrderPaymentsForm";
import NewOrderModalView from "./NewOrderModalView";

@connect(
  (state) => ({
    currentCompany: state.auth.company.model,
    opened: stateSelector(state).opened,
    step: stateSelector(state).step,
    stepLoading: stateSelector(state).stepLoading,
    order: stateSelector(state).form.model,
    valid: stateSelector(state).form.valid,
    errors: stateSelector(state).form.errors,
    slots: stateSelector(state).slotsData.model,
    calculateLoading: stateSelector(state).calculate.fetchLoading,
    calculateFailed: stateSelector(state).calculate.fetchFailed,
    submitLoading: stateSelector(state).form.submitLoading,
  }),
  (dispatch) =>
    bindActionCreators(
      {
        open,
        close,
        goBack,
        updateOrder,
        calculatePricing,
        validate,
        submit,
      },
      dispatch
    )
)
export default class NewOrderModal extends React.PureComponent {
  handleModalClose() {
    const { close, order } = this.props;
    if (order.id) {
      st.confirm({
        content: I18n.t("papp.orders.NewOrderModal.confirm_abandon_message"),
        cancelButton: I18n.t("papp.orders.NewOrderModal.confirm_abandon_cancel"),
        confirmButton: I18n.t("papp.orders.NewOrderModal.confirm_abandon_ok"),
      }).then((yes) => yes && close());
    } else {
      close();
    }
  }

  handleGoBackClick() {
    const { goBack } = this.props;
    goBack();
  }

  renderProductModal() {
    const { order, opened, stepLoading, submitLoading, valid, errors, updateOrder, validate, submit, close } =
      this.props;
    return (
      <NewOrderProductModal
        open
        onClose={close}
        order={order}
        loading={stepLoading || submitLoading}
        valid={valid}
        errors={errors}
        onValidate={validate}
        onOrderUpdate={updateOrder}
        onSave={submit}
      />
    );
  }

  renderOrderScheduleForm() {
    const { order, slots, stepLoading, submitLoading, valid, validate, errors, updateOrder, submit } = this.props;
    const canCreateCustomSlot =
      order &&
      st.authorize("create", {
        type: "ProductScheduleSlot",
        company_id: order.company.id,
      });
    return (
      <OrderScheduleForm
        order={order}
        slots={slots}
        loading={stepLoading || submitLoading}
        valid={valid}
        errors={errors}
        onValidate={validate}
        onOrderUpdate={updateOrder}
        onSave={submit}
        canCreateCustomSlot={canCreateCustomSlot}
      />
    );
  }

  renderNewOrderItemsForm() {
    const {
      currentCompany,
      order,
      updateOrder,
      stepLoading,
      calculateLoading,
      calculateFailed,
      submitLoading,
      valid,
      errors,
      calculatePricing,
      validate,
      submit,
    } = this.props;
    const onOrderUpdate = (order) => {
      updateOrder(order);
      calculatePricing();
    };
    return (
      <NewOrderItemsForm
        currentCompany={currentCompany}
        order={order}
        loading={stepLoading || submitLoading}
        calculateLoading={calculateLoading}
        calculateFailed={calculateFailed}
        valid={valid}
        errors={errors}
        onValidate={validate}
        onOrderUpdate={onOrderUpdate}
        onSave={submit}
      />
    );
  }

  renderNewOrderCustomerDetailsForm() {
    const { order, updateOrder, stepLoading, submitLoading, valid, errors, validate, submit } = this.props;
    return (
      <NewOrderCustomerDetailsForm
        order={order}
        loading={stepLoading || submitLoading}
        valid={valid}
        errors={errors}
        onValidate={validate}
        onOrderUpdate={updateOrder}
        onSave={submit}
      />
    );
  }

  renderNewOrderPaymentsForm() {
    const { currentCompany, order, updateOrder, stepLoading, submitLoading, valid, errors, validate, submit } =
      this.props;
    return (
      <NewOrderPaymentsForm
        currentCompany={currentCompany}
        order={order}
        loading={stepLoading || submitLoading}
        valid={valid}
        errors={errors}
        onValidate={validate}
        onOrderUpdate={updateOrder}
        onSave={submit}
      />
    );
  }

  renderOrderModalTitle() {
    const { step } = this.props;

    switch (step) {
      case STEPS.STEP_SCHEDULE:
        return I18n.t("papp.orders.NewOrderModal.schedule_step_title");
      case STEPS.STEP_ORDER_ITEMS:
        return I18n.t("papp.orders.NewOrderModal.order_items_step_title");
      case STEPS.STEP_CUSTOMER_DETAILS:
        return I18n.t("papp.orders.NewOrderModal.customer_details_step_title");
      case STEPS.STEP_PAYMENTS:
        return I18n.t("papp.orders.NewOrderModal.payments_step_title");
      default:
        return null;
    }
  }

  renderOrderModalContent() {
    const { step } = this.props;

    switch (step) {
      case STEPS.STEP_SCHEDULE:
        return this.renderOrderScheduleForm();
      case STEPS.STEP_ORDER_ITEMS:
        return this.renderNewOrderItemsForm();
      case STEPS.STEP_CUSTOMER_DETAILS:
        return this.renderNewOrderCustomerDetailsForm();
      case STEPS.STEP_PAYMENTS:
        return this.renderNewOrderPaymentsForm();
      default:
        return null;
    }
  }

  renderOrderModal() {
    const { opened, order, step, stepLoading, submit, submitLoading, calculateLoading } = this.props;
    return (
      <NewOrderModalView open onClose={this.handleModalClose.bind(this)} loading={stepLoading || submitLoading}>
        <NewOrderModalView.Container>
          <NewOrderModalView.Header>{this.renderOrderModalTitle()}</NewOrderModalView.Header>
          <NewOrderModalView.Content>{this.renderOrderModalContent()}</NewOrderModalView.Content>
          <NewOrderModalView.Actions
            goBack={this.handleGoBackClick.bind(this)}
            submit={submit}
            goBackDisabled={stepLoading || submitLoading || calculateLoading}
            submitDisabled={
              (step === STEPS.STEP_SCHEDULE && !order.product_schedule_slot) ||
              stepLoading ||
              submitLoading ||
              calculateLoading
            }
            submitContent={step === STEPS.STEP_PAYMENTS ? I18n.t("papp.common.save") : I18n.t("papp.common.go_next")}
          />
        </NewOrderModalView.Container>
        <NewOrderModalView.Sidebar>
          <OrderSidebarPreview
            fullHeight
            extended={step < STEPS.STEP_ORDER_ITEMS}
            order={order}
            showSchedule={step > STEPS.STEP_SCHEDULE}
            showBill={step >= STEPS.STEP_ORDER_ITEMS}
            showCustomer={step >= STEPS.STEP_CUSTOMER_DETAILS}
          />
        </NewOrderModalView.Sidebar>
      </NewOrderModalView>
    );
  }

  render() {
    const { opened, order, step } = this.props;
    if (!opened || !order) {
      return null;
    }
    return step === STEPS.STEP_PRODUCT ? this.renderProductModal() : this.renderOrderModal();
  }
}



// WEBPACK FOOTER //
// ./src/modules/orders/NewOrderModal/NewOrderModal.jsx